export default "__VITE_PUBLIC_ASSET__e59d1449__"